import { render } from "./PersonalPassword.vue?vue&type=template&id=d7867ab4"
import script from "./PersonalPassword.vue?vue&type=script&lang=js"
export * from "./PersonalPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__